import HandsontableHelper from "@/helpers/settings/handsontable";

const ContextMenu = (instance) => {
  {
    return {
      items: {
        title: {
          name: "Set validation to:",
          renderer: HandsontableHelper.contextMenuTitleRenderer,
          disableSelection: true, // Prevent mouseoever from highlighting the item for selection
          isCommand: true // Prevent clicks from executing command and closing the menu
        },
        setToMinus99: {
          name:
            "<div class='flex'><div class='bg-red-500 rounded-full h-3 w-3 flex items-center justify-center mr-1 mt-1'></div><div>Not valid due to station maintenance or calibration (-99)</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: (o, x) => {
            instance.updateValidationFlag(-99, x);
          }
        },
        setToMinus1: {
          name:
            "<div class='flex'><div class='bg-red-500 rounded-full h-3 w-3 flex items-center justify-center mr-1 mt-1'></div><div>Not valid (-1)</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: (o, x) => {
            instance.updateValidationFlag(-1, x);
          }
        },
        setTo1: {
          name:
            "<div class='flex'><div class='bg-green-500 rounded-full h-3 w-3 flex items-center justify-center mr-1 mt-1'></div><div>Valid (1)</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: (o, x) => {
            instance.updateValidationFlag(1, x);
          }
        },
        setTo2: {
          name:
            "<div class='flex'><div class='bg-green-500 rounded-full h-3 w-3 flex items-center justify-center mr-1 mt-1'></div><div>Valid, but below detection limit measurement value given (2)</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: (o, x) => {
            instance.updateValidationFlag(2, x);
          }
        },
        setTo3: {
          name:
            "<div class='flex'><div class='bg-green-500 rounded-full h-3 w-3 flex items-center justify-center mr-1 mt-1'></div><div>Valid, but below detection limit and number replaced by 0.5*detection limit (3)</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: (o, x) => {
            instance.updateValidationFlag(3, x);
          }
        }
      }
    }
  };
};
export default ContextMenu;